import { Col, Container, Row } from "reactstrap";

const Description = () => {
  return (

          <Col lg={12} className="section" id="description">
            <div className="text-center w-75 mx-auto">
              <p className="user-review">
                <span className="fw-bold">Business and Hotel Management School (BHMS)</span>,
                  adalah sekolah swasta yang berorientasi internasional di bidang bisnis 
                  dan perhotelan, berlokasi di Lucerne, Swiss, yang dikenal karena 
                  keunggulan pendidikan Swiss dan fokus karir yang kuat. 
                  BHMS menduduki peringkat #16 secara global untuk Employer 
                  Reputation (QS by subject) dan merupakan salah satu dari 
                  enam sekolah Swiss yang dinilai sebagai institusi bintang lima. 
                  BHMS menggabungkan kurikulum akademis yang ketat dengan pembelajaran 
                  praktis dan magang berbayar yang dijamin, sehingga lulusannya siap 
                  untuk berkarier di bidang perhotelan, bisnis, dan seni kuliner secara global.
              </p>
            </div>
          </Col>

  );
};

export default Description;